module.exports = __webpack_public_path__ + "img/deezer.15bc369d.png";